import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
const Loading = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-between gap-4 m-4 md:gap-0 md:m-8"><Shimmer height="20px" width="100%" className="max-w-[305px]" /><Shimmer height="20px" width="72px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col">{t0}<div className="flex flex-col gap-1"><Shimmer height="20px" width="100%" className="px-2 py-1" /><Shimmer height="20px" width="100%" className="px-2 py-1" /><Shimmer height="20px" width="100%" className="px-2 py-1" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Loading;